module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAD1BMVEUAAADMzMzMzMzV1dXMzMzUkzi8AAAABHRSTlMA5ogGBMV9/gAAAE5JREFUOMtjQABmRSEDBmyAycVFAasEo4uLAFYJFhcXh1GJoSdhJOKCBTgqM6i4YAVODBANmFpwSuA0CqflgzSsRiVIlEAUGYQLGZzFEgA1g0TNHUfZggAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/check_city.png
// module id = 0T5D
// module chunks = 0